// extracted by mini-css-extract-plugin
export default {"loadingContainer":"style_loadingContainer__kkCUB","loadingContent":"style_loadingContent__1-n9d","loadingText":"style_loadingText__EEN6l"};